//文字コードはutf-8

/**
 * KVセクションのズームアウトアニメーション
 * ページリロード時にアニメーションを実行
 */
export function initKvZoomAnimation() {
  const kvElements = document.querySelectorAll('.modKv--topCreator, .modKv--fashionCreator, .modKv--costumeDesign');
  
  if (kvElements.length === 0) {
    return;
  }

  const ANIMATION_DURATION = 10000;

  // ページロード時にアニメーションクラスを追加
  kvElements.forEach(function(kvElement) {
    // アニメーションクラスを追加
    kvElement.classList.add('is-zoom-out');
    
    // アニメーション終了後にクラスを削除（次回のリロードまでアニメーションは実行されない）
    setTimeout(function() {
      kvElement.classList.remove('is-zoom-out');
    }, ANIMATION_DURATION);
  });
}

